import http from '../utils/axiosProvider';
import VelarService from './VelarService';
import { openContractCall } from '@stacks/connect';
import { AnchorMode, FungibleConditionCode, PostConditionMode, createAssetInfo, createSTXPostCondition, estimateContractFunctionCall, makeContractFungiblePostCondition, makeStandardSTXPostCondition } from '@stacks/transactions';
import BigNum from 'bn.js';
import { stringify, toJSON } from '../helper';
import { AppConstants } from '../constants';
import SwapService from './SwapService';
import PoolService from './PoolService';
import StakeService from './StakeService';
import FarmService from './FarmService';
import { getTransactions, setTransactionIntervalLoader, setTransactionLoader } from "../store/slices/chainSlice";
import { Config } from '../config';
import { getWalletProviders } from '../utils/walletUtils';

export class ContractService { 
    constructor (contractAddress, contractName) {
        this.contractAddress = contractAddress;
        this.contractName = contractName;
        this.pureContractAddress = `${contractAddress}.${contractName}`
    }

    async callReadOnly (fn, payload) {
       return (await http.post(`/v2/contracts/call-read/${this.contractAddress}/${this.contractName}/${fn}`, payload))
    }

    async callPublicFunction (functionName, functionArgs = [], postConditions = [], transactionApiPayload = {}, mode = PostConditionMode.Deny) {
        const store = window.velarStore;
        const dispatch = store?.dispatch;
        const state = store.getState();
        const wallet = state?.auth?.authData?.wallet || 'hiro';
        const provider = getWalletProviders(wallet);
        
        return new Promise (async (resolve, reject) => {
            const options = {
                contractAddress: this.contractAddress,
                contractName: this.contractName,
                functionName: functionName,
                functionArgs: functionArgs,
                network: VelarService.getNetwork(),
                appDetails: VelarService.getAppDetails(),
                postConditions: postConditions,
                postConditionMode: mode,
                anchorMode: AnchorMode.Any,
                onFinish: (data) => {
                    if (!data) {
                        resolve({});
                        return;
                    }

                    const txJSON = toJSON(stringify(data));
                    console.log(txJSON);
                    
                    try {
                        const localData = JSON.parse(localStorage.getItem('wallet-state'));
                        transactionApiPayload.walletInUse = localData.wallet;
                    } catch (error) {}

                    transactionApiPayload.fee = 0;
                    transactionApiPayload.txId = txJSON.txId;
                    transactionApiPayload.status = '';
                    transactionApiPayload.exchangeRate = '';
                    transactionApiPayload.txResponse = txJSON;
                    transactionApiPayload.transactionHash = txJSON.txId
                    this.saveTransaction(functionName, transactionApiPayload).then((res) => {});

                    setTimeout(() => {
                        if (dispatch) {
                            dispatch(setTransactionIntervalLoader(true));
                            dispatch(getTransactions());
                        }
                    }, 3000);

                    resolve(data);
                },
                onCancel: (ex) => {
                    console.log(ex);
                    reject();
                },
            };
            await openContractCall(options, provider);
        });
    }

    async saveTransaction (functionName, transactionApiPayload) {
        if (AppConstants.SWAP_FUNCTIONS.includes(functionName) && this.pureContractAddress === Config.ContractAddresses.Router) {
            await SwapService.saveTransaction(transactionApiPayload);
        } else if (AppConstants.POOL_FUNCTIONS.includes(functionName) && this.pureContractAddress === Config.ContractAddresses.Router) {
            await PoolService.saveTransaction(transactionApiPayload);
        } else if (AppConstants.STAKE_FUNCTIONS.includes(functionName) && this.pureContractAddress === Config.ContractAddresses.Staking) {
            await StakeService.saveTransaction(transactionApiPayload);
        } else if (AppConstants.STAKE_FUNCTIONS.includes(functionName) && this.pureContractAddress === Config.ContractAddresses.FarmStaking) {
            await FarmService.saveTransaction(transactionApiPayload);
        }
    }
}